import { Component, OnInit,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResetPasswordService } from './reset-password.service';
import { ResetPassword } from './reset-password';
import { AuthService } from '../services/auth.service';
import { Title } from '@angular/platform-browser';
import { Config } from '../../config/config';
import {Subscription} from 'rxjs';

var Base64 = require('js-base64').Base64;

@Component({
    selector: 'vnpt-login',
    templateUrl: './reset-password.component.html',
    providers: [ResetPasswordService]
    
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    
    emailCheck:string ="";
    resetPasswordErrorStatus:string="";
    item:ResetPassword; 
    private subscription: Subscription;
    loading:boolean=false;
    success:boolean=false;
    fail:boolean = true;

    constructor(private service: ResetPasswordService,
        public authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private titleService: Title) {
        titleService.setTitle("Lấy lại mật khẩu");
    }

    ngOnInit() {
        this.authService.showHeader = false;
        this.authService.showFooter = false;
        this.emailCheck = "";
        this.item = new ResetPassword();
        this.subscription = this.activatedRoute.queryParams.subscribe(
        (param: any) => {
            this.item.UserId = param['userId'];
            this.item.Code = param['code'];
            console.log(this.item);
        });
    }
    ngOnDestroy() {
        // prevent memory leak by unsubscribing
        this.subscription.unsubscribe();
    }

    login() {
       console.log(this.item);
       this.loading = true
       this.resetPasswordErrorStatus = "Đang xử lý dữ liệu, vui lòng chờ trong giây lát";
       this.service.resetPassword(this.item).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.success= true;
                        this.fail = true;
                        this.resetPasswordErrorStatus = resp.Message;
                    }
                    else {
                        this.success= false;
                        this.fail = false;
                        this.resetPasswordErrorStatus = resp.Message;
                    }
                    this.loading = false;
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                }
            )
       
    }
 
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/reset-password/reset-password.component.ts